export default "__VITE_ASSET__BIaHZx$D__"